import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        container: {
            rowGap: 2,
            columnGap: 6,
            direction: {base: 'column', lg: 'row'},
            wrap: 'wrap'
        },
        label: {
            ...textStyles['Regular Medium'],
            flexBasis: {lg: '100%', xl: 'auto'}
        },
        itemContainer: {
            spacing: 2,
            direction: 'row',
            alignItems: 'center'
        },
        image: {},
        itemLabel: {
            ...textStyles['"Semi Bold Medium"']
        }
    },
    variants: {
        cro006: {
            container: {
                backgroundColor: 'stokkeCore.white',
                padding: '1rem',
                gap: '0.5rem',
                direction: 'column'
            },
            itemContainer: {
                alignItems: 'flex-start'
            },
            label: {
                ...textStyles['Semi Bold Medium'],
                flexBasis: '100%'
            }
        }
    },
    parts: ['container', 'stackContainer', 'itemContainer', 'image', 'itemLabel']
}
